"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _transitions = require("@titelmedia/bricks-theme/lib/variables/transitions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var VISIBILITY_THRESHOLD = 3;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .swiper-wrapper {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n  }\n\n  @media screen and (max-width: 640px) {\n    .swiper-slide {\n      padding: 0 20px;\n    }\n  }\n"])));

exports.Container = Container;

var Image = _styledComponents.default.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  opacity: ", ";\n  transition: opacity ", " ease;\n"])), function (props) {
  return props.imageIndex >= props.activeIndex - VISIBILITY_THRESHOLD && props.imageIndex < props.activeIndex + VISIBILITY_THRESHOLD ? 1 : 0;
}, _transitions.TRANSITIONS.REGULAR);

exports.Image = Image;